const COMPACT_RETAIL_CODE_PATTERN = /^(?=.*\d)[a-z0-9]{4,64}$/;

const compactItemCode = (value) =>
    String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");

export const buildSeparatorTolerantRetailSearchTerm = (searchTerm) => {
    const compactSearchTerm = String(searchTerm || "").trim().toLowerCase();
    if (!COMPACT_RETAIL_CODE_PATTERN.test(compactSearchTerm)) return null;

    return compactSearchTerm.split("").join("%");
};

export const filterRetailItemsByCompactCode = (items, searchTerm) => {
    const compactSearchTerm = String(searchTerm || "").trim().toLowerCase();
    if (!COMPACT_RETAIL_CODE_PATTERN.test(compactSearchTerm)) return [];

    return (items || []).filter((item) =>
        compactItemCode(item?.item_code).startsWith(compactSearchTerm)
    );
};
